// src/components/home/CommunitySupport.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { FaHeart, FaStar, FaProductHunt, FaRocket } from "react-icons/fa";
import "./CommunitySupport.css";

const CommunitySupport = () => {
  const navigate = useNavigate();

  return (
    <section className="community-section" data-aos="zoom-in">
      <div className="community-glass-card">
        <span className="community-badge">
          <FaHeart style={{ marginRight: "0.4rem", color: "#fb7185" }} /> Help Us Grow
        </span>
        <h2 className="community-title">Help Build BodhAI</h2>
        <p className="community-desc">
          We're building BodhAI to create a smarter and more engaging learning experience.
          Every upvote, comment, and feedback helps us improve.
        </p>

        <div className="community-stars">
          <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
        </div>
        <p className="community-quote">Loved by early beta users, students, and educators</p>

        <div className="community-actions">
          <a
            href="https://www.producthunt.com/products/bodhai?utm_source=bodhai.pages.dev&utm_medium=referral&utm_campaign=bodhai_product_launch_july_2026&utm_content=visit_producthunt_from_bodhai_homepage&utm_term=ai_learning_tool_launch"
            target="_blank"
            rel="noopener noreferrer"
            className="community-btn primary"
          >
            <FaProductHunt /> Support on Product Hunt
          </a>
          <button
            className="community-btn secondary"
            onClick={() => navigate("/register")}
          >
            <FaRocket /> Join Beta
          </button>
        </div>
      </div>
    </section>
  );
};

export default React.memo(CommunitySupport);
